<div class="custom-dropdown border-radius radius-top-right">
  <div
    app-search
    class="w-100"
    [active]="false"
    placeholder="Search customers..."
    [SearchBtn]="false"
    [disabled]="false"
    size="medium"></div>
  @if (state == 'default') {
    <ul class="filter-dropdown h3-bold primary-100 m-0">
      @for (customer of customers; track customer) {
        <li
          class="justify-content-start"
          (click)="onItemSelected(customer.name && customer.email); onClick.emit(customer)">
          <app-content-type
            name="{{ customer.name }}"
            mail="({{ customer.email }})"
            [Type]="'person'"></app-content-type>
        </li>
      }
    </ul>
  }
  @if (state == 'empty-state') {
    <div
      class="empty-data d-flex flex-column spacing-12 justify-content-center align-items-center w-100 pt-24 pb-24">
      <app-icon-container
        [Type]="'icon'"
        [Size]="'large'"
        [IconType]="'search'"
        [background_color]="'primary-20'"></app-icon-container>
      <div class="d-flex flex-column spacing-4 justify-content-center align-items-center">
        <h3 class="h3-bold primary-80 m-0 p-0">{{ title }}</h3>
        <p class="h4-reg p-0 m-0 primary-60">No users were found matching the search criteria.</p>
      </div>
    </div>
  }
</div>
